module.exports = __webpack_public_path__ + "img/wifi-camera.26b9ae4.png";